import React from "react";
import PropTypes from "prop-types";
import { InputText, Label } from "../../../../components/Inputs";
import { ProfilePhoto } from "../../../Profile/components";
import BasicProfileDataMenu from "../BasicProfileDataMenu";

export default function BasicDataPanel({
  className = "",
  model = {
    username: "",
    firstname: "",
    lastname: "",
    email: "",
    cellNumber: "",
    company: "",
    roles: [],
    extendedRoles: [],
    image: null,
  },
  menu = null,
}) {
  const { firstname, lastname, username, email, cellNumber, companies, image } =
    model;
  const company = companies && companies.length > 0 ? companies[0] : {};
  const roles = (company.roles || []).concat(company.extendedRoles || []);

  return (
    <div className={className}>
      <div className="clearfix">
        <div className="w3-right">{menu || <BasicProfileDataMenu />}</div>
        <h3 className="no-margin-top">{`${firstname} ${lastname}`}</h3>
      </div>
      <div className="w3-row neg-margin-lr">
        <div className="w3-col s10 pad-lr">
          <div className="w3-row neg-margin-lr pad-top">
            <div className="w3-col m6 l3 pad-lr">
              <Label>{`Mitarbeiterprofil`}</Label>
              <InputText className="w3-block" value={username} readonly />
            </div>
            <div className="w3-col m6 l3 pad-lr">
              <Label>{`E-Mail`}</Label>
              <InputText className="w3-block" value={email} readonly />
            </div>
            <div className="w3-col m6 l3 pad-lr">
              {/* <Label>{`Telefon (mobil)/Festnetz`}</Label>
              <InputText className="w3-block" value={cellNumber} readonly /> */}
              <Label>{`Telefon (dienstlich)`}</Label>
              <InputText
                className="w3-block"
                value={company.telephoneNumber}
                readonly
              />
            </div>
          </div>
          <div className="w3-row neg-margin-lr pad-big-top">
            <div className="w3-col m6 l3 pad-lr">
              <Label>{`Beschäftigt bei`}</Label>
              <InputText className="w3-block" value={company.name} readonly />
            </div>
            <div className="w3-col m6 l3 pad-lr">
              <Label>{`KDL/DL`}</Label>
              <InputText
                className="w3-block"
                value={company.contractGiver}
                readonly
              />
            </div>
            <div className="w3-col m6 l3 pad-lr">
              <Label>{"Position"}</Label>
              <div>
                {roles.map((role, index) => (
                  <InputText
                    key={`role${index}`}
                    className="w3-block"
                    value={role}
                    readonly
                  />
                ))}
              </div>
            </div>
            <div className="w3-col m6 l3 pad-lr">
              {/* <Label>{`Telefon (dienstlich)`}</Label>
              <InputText
                className="w3-block"
                value={company.telephoneNumber}
                readonly
              /> */}
              <Label>{`Vodafone Organisationseinheit`}</Label>
              <InputText
                className="w3-block"
                value={company.organisationUnit}
                readonly
              />
            </div>
          </div>
        </div>
        <div className="w3-col s2 pad-lr">
          <ProfilePhoto className="margin-top" image={image} />
        </div>
      </div>
    </div>
  );
}

BasicDataPanel.propTypes = {
  className: PropTypes.string,
  model: PropTypes.object,
  menu: PropTypes.node,
};
